import { useEffect, useMemo, useState } from 'react';
import useSlingApi from '@sdk/api/useSlingApi';
import debounce from 'lodash/debounce';

import { BillingAddress } from '@web/account/types';

export const useTaxCalculations = (
  billingAddress: BillingAddress,
  subscriptionLevel: number,
  isYearlyPlan: boolean
) => {
  const api = useSlingApi();
  const [taxPercent, setTaxPercent] = useState(0);

  const fetchTaxRates = useMemo(
    () =>
      debounce((address: BillingAddress) => {
        async function fetchRates() {
          const { data } = await api.account.getTaxRates({
            billingAddress: address,
            subscriptionLevel,
            isYearlyPlan,
          });

          setTaxPercent(data?.taxPercent || 0);
        }

        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        fetchRates();
      }, 1000),
    [api.account, isYearlyPlan, subscriptionLevel]
  );

  useEffect(() => {
    fetchTaxRates.cancel();
  }, [fetchTaxRates]);

  useEffect(() => {
    if (billingAddress) {
      fetchTaxRates(billingAddress);
    }
  }, [billingAddress, fetchTaxRates]);

  return { taxPercent };
};
